import { render, staticRenderFns } from "./VEstimatesPositionsTable.vue?vue&type=template&id=01e54f0a&"
import script from "./VEstimatesPositionsTable.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesPositionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesPositionsTable.vue?vue&type=style&index=0&id=01e54f0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports